import React from "react";
import "./Ressourcen/Calender.css"
import easyjob_logo from "./Ressourcen/easyjob_logo.png"
import pdf_logo from "./Ressourcen/PDF_file_icon.png"
import Job from "./Job"
import {get_width, get_duration, get_offset} from "./Calendar"

import Cookies from "js-cookie";
import {log} from "util";

function Project(props) {
    const {project_details, general_duration, background, filter_name} = props;
    const {id, name, jobs, tage} = project_details
    const project_style = {
        //marginBottom: "5px",
        width: get_width(tage[0], tage[1], general_duration) + '%',
        marginLeft: get_offset(tage[0], general_duration),
        backgroundColor: background,
        marginBottom: '9px',
        border:'1px solid grey',
        borderRadius:'8px',
        boxShadow: '5px -5px 5px rgba(0, 0, 0, 0.4)'


        //borderTop: "3px solid #0d6efd"
    }
    const send_Command = () => {
        console.log("openProjekt")
        fetch(`https://ej.puzzlepie.de/api.json/Common/SendCommand`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                Authorization: Cookies.get("token")
            },
            body: JSON.stringify({
                /*1 = easyjob*/
                "ClientType": 1,

                /*Command*/
                "Command": "easyjob:OpenProject?id=" + id,

                /*(optional) Client ID (default: 0)*/
                /* 0 = all active easyjob instances*/
                "IdClient": 0
            })
        }).then()
    }
    const get_attachments = async (shortcutid, shoutcutcaption) => {
        let filetype = shoutcutcaption.split(".")
        console.log(filetype)
        filetype = filetype[filetype.length - 1]
        let contenttype = null

        switch (filetype.toLowerCase()) { // Sicherer: kleinbuchstabig vergleichen
            case "jpg":
            case "jpeg":                   // Optional: jpg + jpeg abfangen
                contenttype = "image/jpeg";
                break;
            case "png":
                contenttype = "image/png";
                break;
            case "pdf":
                contenttype = "application/pdf";
                break;
            default:
                console.warn("Unbekannter Dateityp:", filetype);
        }

        fetch(`https://ej.puzzlepie.de/Shortcuts/Download/` + shortcutid, {
                method: 'GET',
                headers: {
                    Authorization: Cookies.get("token"),
                },
            }
        ).then(async response => {
            console.log(response);
            const reader = response.body.getReader();
            const chunks = [];
            while (true) {
                const {done, value} = await reader.read();
                if (done) break;
                chunks.push(value);
            }
            return new Blob(chunks, {type: contenttype});
        })
            .then(file => URL.createObjectURL(file)).then(fileurl => window.open(fileurl))
    }




    return (
        <div style={project_style}>
            <div style={{ margin: "5px"}}>
                <div style={{display: "flex"}}>
                    <p>Project: {project_details.projectnumber} | {name}</p>

                    {id === 0 ? null : <img src={easyjob_logo} onClick={send_Command} alt={"easyjob_link"}
                                            style={{marginLeft: "6px", marginTop: "3px", height: "15px"}}/>}
                </div>

                {project_details.customer ? <p>🏭 {project_details.customer.Company}</p> : null}
                {project_details.attachments ? <div>
                    {project_details.attachments.map((attachments, index) => (
                        <div key={index} style={{display: "flex"}} onClick={() => get_attachments(attachments.attachmentsId, attachments.Caption)}>
                            <img src={pdf_logo} alt={"pdf_link"}
                                 style={{ marginTop: "3px", height: "15px",cursor:  'pointer' }}/>
                            <p style={{marginLeft: "5px",cursor:  'pointer'}}>{attachments.Caption}</p>
                        </div>

                    ))}
                </div> : null}
            </div>
            {jobs.map((job, index) => (
                <div key={index}>
                    <Job key={index} id={job.id} name={job.name} tage={job.tage} slots={job.slots}
                         project_duration={get_duration(tage[0], tage[1])} adress={job.adress} hidden={job.hidden}
                         filter_name={filter_name} job_details={job}/>
                </div>
            ))}

        </div>

    )
}

export default Project
